import { Box, Typography } from "@mui/material";
import { HOOPER_NEON_GREEN } from "../../shared/constants";

const FooterOverlay = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box sx={{ mb: 4, px: 4 }}>
      <Typography sx={{ textAlign: "center", color: HOOPER_NEON_GREEN }}>
        Copyright © {currentYear} Built Different AI Inc. All rights reserved.
      </Typography>
    </Box>
  );
};

export default FooterOverlay;
